// /zh-TW シミュレーション時の ATOMS グローブ基本価格（税込・表示は getPriceUnit に準拠）
export const glovePriceTaxIncluded = 99000 // 硬式グラブ
export const mittPriceTaxIncluded = 103400 // 硬式ミット
export const softGloveBasePrice = 78100 // 軟式グラブ
export const softMittBasePrice = 81400 // 軟式ミット
